import React, { useState, useEffect } from 'react'
import Modal from 'react-responsive-modal'
import styles from './index.module.css'
import { useDispatch, useSelector } from 'react-redux'
import { getStudentsForEnroll } from '../../../actions/groupsDoVd'
import { getParallels, getClassesByYear, getCLasses } from '../../../actions/common'
import { Select, Input, Checkbox } from '../../../components/ModalInputs'
import Button from '../../../components/Button'
import Loader from '../../../components/Loader'
import moment from 'moment'

export default function EnrollModal({ isOpen, onClose, onSave, existingMids = [] }) {
    const dispatch = useDispatch();
    const { students, studentsLoading } = useSelector(state => state.groups_do_vd);
    const { parallels, classes } = useSelector(state => state.common);

    const [filters, setFilters] = useState({
        parallel: '',
        class_id: ''
    });
    const [selectedIds, setSelectedIds] = useState([]);
    const [enrollDate, setEnrollDate] = useState(moment().format('YYYY-MM-DD'));

    useEffect(() => {
        if (isOpen) {
            dispatch(getParallels());
            dispatch(getCLasses());
            dispatch(getStudentsForEnroll({ status: 'current' }));
            setFilters({ parallel: '', class_id: '' });
        }
    }, [isOpen]);

    useEffect(() => {
        if (isOpen) {
            setSelectedIds([]);
        }
    }, [isOpen]);

    // При изменении параллели - загружаем классы и обновляем студентов
    const handleParallelChange = (value) => {
        setFilters(prev => ({ ...prev, parallel: value, class_id: '' }));

        const params = { status: 'current' };
        if (value) {
            params.parallel = value;
            dispatch(getClassesByYear(value));
        } else {
            dispatch(getCLasses());
        }
        dispatch(getStudentsForEnroll(params));
    };

    // При изменении класса - обновляем студентов с параметром gid
    const handleClassChange = (value) => {
        setFilters(prev => ({ ...prev, class_id: value }));

        const params = { status: 'current' };
        if (filters.parallel) params.parallel = filters.parallel;
        if (value) params.gid = value;
        dispatch(getStudentsForEnroll(params));
    };

    const handleRefresh = () => {
        const params = { status: 'current' };
        if (filters.parallel) params.parallel = filters.parallel;
        if (filters.class_id) params.gid = filters.class_id;
        dispatch(getStudentsForEnroll(params));
    };

    const handleSelect = (e, mid) => {
        if (e.target.checked) {
            setSelectedIds(prev => [...prev, mid]);
        } else {
            setSelectedIds(prev => prev.filter(id => id !== mid));
        }
    };

    const handleRowClick = (mid) => {
        if (selectedIds.includes(mid)) {
            setSelectedIds(prev => prev.filter(id => id !== mid));
        } else {
            setSelectedIds(prev => [...prev, mid]);
        }
    };

    const handleSave = () => {
        const selectedStudents = filteredStudents.filter(s => {
            const mid = s.mid || s.xp_key;
            return selectedIds.includes(mid);
        });
        onSave(selectedIds, enrollDate, selectedStudents);
        setSelectedIds([]);
    };

    const handleClose = () => {
        setSelectedIds([]);
        onClose();
    };

    // Фильтруем только уже зачисленных (остальное фильтруется на сервере)
    const filteredStudents = students?.filter(s => {
        const mid = s.mid || s.xp_key;
        return !existingMids.includes(mid);
    }) || [];


    return (
        <Modal
            open={isOpen}
            onClose={handleClose}
            center
            closeOnOverlayClick={false}
            classNames={{ modal: styles.modal }}
        >
            <div className={styles.header}>
                Зачисление группы
            </div>

            <div className={styles.content}>
                <div className={styles.filters}>
                    <div className={styles.filterItem}>
                        <Select
                            label='Параллель'
                            value={filters.parallel}
                            onChange={(e) => handleParallelChange(e.target.value)}
                        >
                            <option value=''>Все</option>
                            {parallels?.map((el) => (
                                <option key={el.year || el.value || el} value={el.year || el.value || el}>
                                    {el.kurs_name || el.name || el}
                                </option>
                            ))}
                        </Select>
                    </div>

                    <div className={styles.filterItem + ' ' + styles.filterItemClass}>
                        <Select
                            key={`class-select-${classes?.length}-${classes?.[0]?.gid || ''}`}
                            label='Класс'
                            value={filters.class_id}
                            onChange={(e) => handleClassChange(e.target.value)}
                        >
                            <option value=''>Все</option>
                            {classes?.map((el) => (
                                <option key={el.gid || el.xp_key || el.id} value={el.gid}>
                                    {el.name}
                                </option>
                            ))}
                        </Select>
                    </div>

                    <Button className={styles.refreshBtn} onClick={handleRefresh}>
                        Обновить
                    </Button>
                </div>

                {studentsLoading ? (
                    <div style={{ display: 'flex', justifyContent: 'center', padding: '2rem' }}>
                        <Loader />
                    </div>
                ) : (
                    <div className={styles.tableWrapper}>
                        <table className={styles.table}>
                            <thead>
                                <tr>
                                    <th>ФИО</th>
                                    <th>Класс</th>
                                    <th>Дата зачисления</th>
                                    <th style={{ width: '60px' }}>Выбрать</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredStudents.map((student) => {
                                    const mid = student.mid || student.xp_key;
                                    const isSelected = selectedIds.includes(mid);
                                    return (
                                        <tr
                                            key={mid}
                                            className={isSelected ? styles.selected : ''}
                                            onClick={() => handleRowClick(mid)}
                                        >
                                            <td>{student.fio || `${student.lastname} ${student.firstname} ${student.midname || ''}`}</td>
                                            <td>{student.school_class}</td>
                                            <td>{student.enrollment_date}</td>
                                            <td onClick={(e) => e.stopPropagation()}>
                                                <Checkbox
                                                    checked={isSelected}
                                                    onChange={(e) => handleSelect(e, mid)}
                                                />
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                )}

                <div className={styles.info}>
                    <span>Всего строк: {filteredStudents.length}</span>
                    <span>Выделено строк: {selectedIds.length}</span>
                </div>

                <div className={styles.dateField}>
                    <label>Зачислить с даты:</label>
                    <Input
                        type='date'
                        value={enrollDate}
                        onChange={(e) => setEnrollDate(e.target.value)}
                        style={{ width: '180px' }}
                    />
                </div>
            </div>

            <div className={styles.footer}>
                <Button onClick={handleSave} disabled={selectedIds.length === 0}>
                    Выбрать
                </Button>
                <Button mode='white' onClick={handleClose}>
                    Закрыть
                </Button>
            </div>
        </Modal>
    );
}
